interface ErrorDialogProps {
  title?: string
  message: string
  onClose: () => void
}

function ErrorDialog({ title = 'Error de autenticación', message, onClose }: ErrorDialogProps) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-[#1E3A5F]/40 px-4" role="alertdialog" aria-modal="true" aria-labelledby="error-title">
      <div className="w-full max-w-md border border-[#1E3A5F]/15 bg-[#F4EFE6] p-6 shadow-xl">
        <h2 id="error-title" className="font-['Fraunces'] text-xl">
          {title}
        </h2>
        <p className="mt-3 text-sm leading-relaxed text-[#1E3A5F]/75">{message}</p>
        <button
          type="button"
          onClick={onClose}
          className="mt-6 border border-[#1E3A5F] px-4 py-2 text-sm hover:bg-[#1E3A5F] hover:text-[#F4EFE6]"
        >
          Entendido
        </button>
      </div>
    </div>
  )
}

export default ErrorDialog
